module.exports = __webpack_public_path__ + "static/media/icono_filosofia.f975f551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icono_filosofia.png
// module id = 809
// module chunks = 0